"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[893],{

/***/ 6893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t3": function() { return /* binding */ ResponsiveImage; }
});

// UNUSED EXPORTS: ImageMemo, getOriginalImageDimensions, getResponsiveImageUrl, imageBuilder

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@sanity/image-url/lib/browser/image-url.umd.js
var image_url_umd = __webpack_require__(6803);
var image_url_umd_default = /*#__PURE__*/__webpack_require__.n(image_url_umd);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./helpers/utils/number.ts
/**
 * Wraps a number when it breaches the defined range.
 *
 * wrap accepts a range, defined as a min and max.
 *
 * When a third number is provided:
 *
 * If it lies within the range, it is returned.
 * If it lies outside the range, it is wrapped back around:
 *
 * wrap(0, 1, 0.5); // 0.5
 * wrap(0, 1, 1.5); // 0.5
 */ var wrap = function(min, max, v) {
    var rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};
/**
 * Round a number to the nearest multiple of another number.
 */ var roundToNearest = function(multiple, v) {
    if (multiple === 0) return Math.round(v);
    return Math.round(v / multiple) * multiple;
};
/**
 * Random number between two numbers.
 */ var randomBetween = function(min, max) {
    return Math.random() * (max - min) + min;
};

// EXTERNAL MODULE: ./hooks/useDebounce.ts
var useDebounce = __webpack_require__(4841);
// EXTERNAL MODULE: ./components/meta/ScriptJsonLd.tsx
var ScriptJsonLd = __webpack_require__(18164);
;// CONCATENATED MODULE: ./components/images/ResponsiveImage.tsx











var imageBuilder = image_url_umd_default()({
    projectId: "k6y0mpps",
    dataset: "production"
});
var IMAGE_QUALITY = 85;
var ratioClasses = {
    auto: "aspect-auto",
    "1/1": "aspect-[1/1]",
    "3/2": "aspect-[3/2]",
    "16/9": "aspect-[16/9]",
    "19/27": "aspect-[19/27]",
    "2/1": "aspect-[2/1]",
    "13/8": "aspect-[13/8]",
    "4/3": "aspect-[4/3]",
    "21/9": "aspect-[21/9]"
};
var ResponsiveImage = function(param) {
    var src = param.src, width = param.width, height = param.height, crop = param.crop, hotspot = param.hotspot, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _layout = param.layout, layout = _layout === void 0 ? "intrinsic" : _layout, objectFit = param.objectFit, className = param.className, _preventResize = param.preventResize, preventResize = _preventResize === void 0 ? false : _preventResize, priority = param.priority, ratio = param.ratio, _roundSize = param.roundSize, roundSize = _roundSize === void 0 ? 0 : _roundSize, dpr = param.dpr;
    var wrapperRef = (0,react.useRef)(null);
    var placeholderRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), responsiveSrc = ref[0], setResponsiveSrc = ref[1];
    var ref1 = (0,react.useState)(null), state = ref1[0], setState = ref1[1];
    var ref2 = (0,react.useState)(0), wrapperWidth = ref2[0], setWrapperWidth = ref2[1];
    var ref3 = (0,react.useState)(0), wrapperHeight = ref3[0], setWrapperHeight = ref3[1];
    var debouncedWrapperWidth = (0,useDebounce/* useDebounce */.N)(wrapperWidth, 500);
    var debouncedWrapperHeight = (0,useDebounce/* useDebounce */.N)(wrapperHeight, 500);
    var originalDimensions = getOriginalImageDimensions(src);
    if (!width) width = originalDimensions === null || originalDimensions === void 0 ? void 0 : originalDimensions.width;
    if (!height) height = originalDimensions === null || originalDimensions === void 0 ? void 0 : originalDimensions.height;
    var aspectRatio = originalDimensions === null || originalDimensions === void 0 ? void 0 : originalDimensions.aspectRatio;
    var placeHolderSrc;
    // if (ratio) {
    //   height = (+width / +ratio.split(':')[0]) * +ratio.split(':')[1];
    // }
    if (src && typeof src === "string" && src.indexOf("sanity.io") > -1) {
        placeHolderSrc = getResponsiveImageUrl({
            src: src,
            width: 16,
            height: 16 / (+width / +height),
            hotspot: hotspot,
            crop: crop,
            blur: 10,
            dpr: dpr
        });
    }
    (0,react.useEffect)(function() {
        if (state === null) setState("loading");
    }, [
        state
    ]);
    var onResize = (0,react.useCallback)(function() {
        if (!src) return;
        if (!(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current)) return;
        if (!placeHolderSrc) return;
        if (typeof src !== "string") return;
        var rect = wrapperRef.current.getBoundingClientRect();
        var w = roundToNearest(roundSize, rect.width);
        var h = roundToNearest(roundSize, rect.height);
        setWrapperWidth(w);
        setWrapperHeight(h);
    }, [
        src,
        placeHolderSrc,
        roundSize
    ]);
    /**
   * Listen to window resizes
   */ (0,react.useEffect)(function() {
        if (!src) return;
        if (!(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current)) return;
        if (typeof ResizeObserver === "undefined") return;
        var resizeObserver = new ResizeObserver(onResize);
        resizeObserver.observe(wrapperRef.current);
        (function() {
            return resizeObserver.disconnect();
        });
    }, [
        wrapperRef,
        src,
        onResize
    ]);
    /**
   * when the debounced window width changes
   * generate new source for sanity images
   */ (0,react.useEffect)(function() {
        if (!src) return;
        if (!placeHolderSrc) return;
        if (typeof src !== "string") return;
        var rect = wrapperRef.current.getBoundingClientRect();
        var newWidth = roundToNearest(roundSize, rect.width);
        var newHeight = roundToNearest(roundSize, rect.height);
        var quality = IMAGE_QUALITY;
        if (preventResize === true) {
            // Do we need to factor in crops as well? https://github.com/sanity-io/hydrogen-sanity-demo/blob/main/src/components/SanityImage.client.jsx#L100
            newHeight = rect.width / (+width / +height);
            quality = null;
        }
        // for layouts where height depends on the image, use image ratio
        if (newHeight === 0) newHeight = newWidth / (+width / +height);
        setResponsiveSrc(getResponsiveImageUrl({
            src: src,
            width: newWidth,
            height: newHeight,
            hotspot: hotspot,
            crop: crop,
            quality: quality,
            dpr: dpr
        }));
    }, [
        wrapperWidth,
        debouncedWrapperHeight,
        width,
        height,
        src,
        crop,
        hotspot,
        preventResize,
        placeHolderSrc,
        roundSize, 
    ]);
    var onImageLoad = (0,react.useCallback)(function() {
        setState("loaded");
    }, []);
    var imageJsonLd = {
        "@context": "https://schema.org/",
        "@type": "ImageObject",
        contentUrl: src,
        description: alt
    };
    if (!src) return null;
    var _obj;
    return(// disable margin underneath next image until classes can be applied to next image directly
    // https://github.com/vercel/next.js/discussions/22861
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("image", "text-0 h-full w-full", (_obj = {}, (0,_define_property/* default */.Z)(_obj, "relative", !objectFit), (0,_define_property/* default */.Z)(_obj, ratioClasses[ratio], ratio), _obj)),
        ref: wrapperRef,
        children: [
            priority && responsiveSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: "".concat(responsiveSrc, "&q=").concat(IMAGE_QUALITY)
                })
            }),
            (state === "loading" || state === "loaded") && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: responsiveSrc || placeHolderSrc || src,
                className: className,
                alt: alt,
                layout: layout,
                width: layout === "fill" ? null : width,
                height: layout === "fill" ? null : height,
                objectFit: objectFit,
                priority: priority,
                loader: function(param) {
                    var src = param.src, width = param.width, _quality = param.quality, quality = _quality === void 0 ? 100 : _quality;
                    return "".concat(src, "&q=").concat(quality);
                },
                quality: IMAGE_QUALITY,
                onLoadingComplete: onImageLoad
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: src,
                        className: className,
                        alt: alt,
                        width: width ? width : "auto",
                        height: height ? height : "auto"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScriptJsonLd/* ScriptJsonLd */.a, {
                data: imageJsonLd
            })
        ]
    }));
};
var ImageMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(ResponsiveImage)));
function getResponsiveImageUrl(param) {
    var src = param.src, width = param.width, height = param.height, crop = param.crop, hotspot = param.hotspot, _blur = param.blur, blur = _blur === void 0 ? 0 : _blur, _quality = param.quality, quality = _quality === void 0 ? IMAGE_QUALITY : _quality, dpr = param.dpr;
    if (!src) return null;
    var ref = getOriginalImageDimensions(src), originalWidth = ref.width, originalHeight = ref.height;
    dpr = dpr ? dpr :  false ? 0 : window.devicePixelRatio || 1;
    var newSrc = imageBuilder.image(src).auto("format");
    if (quality) newSrc = newSrc.quality(IMAGE_QUALITY);
    if (blur) newSrc = newSrc.blur(blur);
    if (width) newSrc = newSrc.width(Math.ceil(width * dpr));
    if (height) newSrc = newSrc.height(Math.ceil(height * dpr));
    if ((hotspot === null || hotspot === void 0 ? void 0 : hotspot.x) && (hotspot === null || hotspot === void 0 ? void 0 : hotspot.y)) newSrc = newSrc.crop("focalpoint").focalPoint(hotspot.x, hotspot.y).fit("crop");
    if (crop && (crop === null || crop === void 0 ? void 0 : crop.left) !== null && (crop === null || crop === void 0 ? void 0 : crop.top) !== null && (crop === null || crop === void 0 ? void 0 : crop.right) !== null && (crop === null || crop === void 0 ? void 0 : crop.bottom) !== null) {
        var rect = {
            left: Math.floor(originalWidth * ((crop === null || crop === void 0 ? void 0 : crop.left) || 0)),
            top: Math.floor(originalHeight * ((crop === null || crop === void 0 ? void 0 : crop.top) || 0)),
            width: originalWidth - Math.floor(originalWidth * ((crop === null || crop === void 0 ? void 0 : crop.right) || 0)) - Math.floor(originalWidth * ((crop === null || crop === void 0 ? void 0 : crop.left) || 0)),
            height: originalHeight - Math.floor(originalHeight * ((crop === null || crop === void 0 ? void 0 : crop.bottom) || 0)) - Math.floor(originalHeight * ((crop === null || crop === void 0 ? void 0 : crop.top) || 0))
        };
        if (rect.width <= 0) rect.width = originalWidth;
        if (rect.height <= 0) rect.height = originalHeight;
        newSrc = newSrc.rect(rect.left, rect.top, rect.width, rect.height);
    }
    return newSrc.url();
}
function getOriginalImageDimensions(src) {
    var ref;
    if (!src) return {
        width: 0,
        height: 0,
        aspectRatio: 0
    };
    var filename = (ref = src === null || src === void 0 ? void 0 : src.split("/")) === null || ref === void 0 ? void 0 : ref.pop();
    var pattern = /-(\d+x\d+)/;
    var ref1 = (0,_sliced_to_array/* default */.Z)(pattern.exec(filename), 2), dimensions = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(dimensions.split("x").map(function(v) {
        return parseInt(v, 10);
    }), 2), width = ref2[0], height = ref2[1];
    var aspectRatio = width / height;
    return {
        width: width,
        height: height,
        aspectRatio: aspectRatio
    };
}


/***/ }),

/***/ 81533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ZoomableImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26126);
/* harmony import */ var _ResponsiveImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6893);







var ZoomableImage = function(param) {
    var enabled = param.enabled, image = param.image;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), zoomEnabled = ref[0], setZoomEnabled = ref[1];
    if (!image) return null;
    if (!enabled) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_3__/* .ResponsiveImage */ .t3, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, image));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_2__/* .TransformWrapper */ .d$, {
        disabled: !enabled || !zoomEnabled,
        maxScale: 3,
        children: function(_param) /*#__PURE__*/ {
            var zoomIn = _param.zoomIn, resetTransform = _param.resetTransform, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
                "zoomIn",
                "resetTransform"
            ]);
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "cursor-zoom-in",
                onClick: function() {
                    if (zoomEnabled) return;
                    setZoomEnabled(true);
                    zoomIn();
                },
                onMouseLeave: function() {
                    setZoomEnabled(false);
                    resetTransform();
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_2__/* .TransformComponent */ .Uv, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_3__/* .ResponsiveImage */ .t3, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, image), {
                        dpr: 3,
                        className: "point-events-none select-none"
                    }))
                })
            });
        }
    });
};


/***/ }),

/***/ 4841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/**
 * Usage:
 * const [searchTerm, setSearchTerm] = useState("");
 * const debouncedSearchTerm = useDebounce(searchTerm, 500);
 */ 
function useDebounce(value, delay) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            return clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}


/***/ }),

/***/ 51063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ImageCard": function() { return /* binding */ ImageCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_Decorations_Lozenge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12433);
/* harmony import */ var _components_images_ZoomableImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81533);








var ratioClasses = {
    "19/27": "aspect-[19/27]",
    "1/1": "aspect-[1/1]",
    "4/3": "aspect-[4/3]"
};
var ImageCard = function(param) {
    var image = param.image, lozengeVariantIndex = param.lozengeVariantIndex, theme = param.theme;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "h-full relative group",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("w-full relative", "rounded-4xl overflow-hidden", ratioClasses[(theme === null || theme === void 0 ? void 0 : (ref = theme.image) === null || ref === void 0 ? void 0 : ref.ratio) || "19/27"], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, "cursor-zoom-in [&_div]:w-full [&_div]:h-full", theme === null || theme === void 0 ? void 0 : (ref1 = theme.image) === null || ref1 === void 0 ? void 0 : ref1.zoom)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_images_ZoomableImage__WEBPACK_IMPORTED_MODULE_4__/* .ZoomableImage */ .X, {
                    image: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, image), {
                        layout: "fill"
                    }),
                    enabled: theme === null || theme === void 0 ? void 0 : (ref2 = theme.image) === null || ref2 === void 0 ? void 0 : ref2.zoom
                })
            }),
            lozengeVariantIndex == 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Decorations_Lozenge__WEBPACK_IMPORTED_MODULE_3__/* .Lozenge */ .OD, {
                color: "blue-light",
                rotation: 2,
                size: "md",
                className: "absolute -right-[5%] -bottom-[12.5%] z-10"
            }),
            lozengeVariantIndex == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Decorations_Lozenge__WEBPACK_IMPORTED_MODULE_3__/* .Lozenge */ .OD, {
                color: "green-light",
                rotation: 10,
                size: "sm",
                className: "absolute -right-[25%] -bottom-[10%] z-10"
            }),
            lozengeVariantIndex == 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Decorations_Lozenge__WEBPACK_IMPORTED_MODULE_3__/* .Lozenge */ .OD, {
                color: "lilac-light",
                rotation: 11,
                size: "lg",
                className: "absolute left-[25%] -top-[0%] z-10 -translate-y-3/4"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(ImageCard));


/***/ })

}]);